import { IApplicationState } from 'reduxStore/types';
export const getEntity = (state: IApplicationState) => state.entity;
